var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#muted_svg__clip0_4177_202390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.333 16.017v-4.35h3.334c1.833 0 3.333-1.5 3.333-3.334C30 6.5 28.5 5 26.667 5h-5C20.75 5 20 5.75 20 6.667v6.016l3.333 3.334zM8.533 5.933a1.66 1.66 0 00-2.35 0c-.65.65-.65 1.7 0 2.35L20 22.117v.466c-1.567-.9-3.5-1.25-5.55-.533-2.233.8-3.95 2.783-4.35 5.117-.767 4.566 3.1 8.466 7.65 7.75 3.267-.517 5.583-3.517 5.583-6.834V25.45l8.367 8.367c.65.65 1.7.65 2.35 0 .65-.65.65-1.7 0-2.35L8.533 5.933z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "muted_svg__clip0_4177_202390"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
export default SvgMuted;